import httpClient from "../httpClient"

import { formatData } from "../request"
import { encodeRequestParameters } from "../request"
import { authorisationsFormat } from "../formats"

export function getAuthorisations(data) {
    data = formatData(authorisationsFormat, data)
    if (data === false) {
        throw "500"
    }
    const params = encodeRequestParameters(data)

    return httpClient
        .get("/autorisation", { params })
        .then((response) => {
            return response
        })
        .catch((error) => {
            throw error
        })
}

export function getAccessOfAuthorisations(id) {
    return httpClient
        .get("/autorisation/" + id + "/access")
        .then((response) => {
            return response
        })
        .catch((error) => {
            throw error
        })
}
